module.exports = __webpack_public_path__ + "img/Trinax-logo.d62e5e9c.png";